import * as types from './constants';

// Create Reimbursement
export const createReimbursementRequest = data => (
  { type: types.CREATE_REIMBURSEMENT_REQUEST, payload: data }
);

export const createReimbursementDone = data => (
  { type: types.CREATE_REIMBURSEMENT_DONE, payload: data }
);

export const createReimbursementFailed = errors => (
  { type: types.CREATE_REIMBURSEMENT_FAILED, payload: errors }
);

export const createReimbursementReset = () => (
  { type: types.CREATE_REIMBURSEMENT_RESET }
);